exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-borders {\n    border : 0px solid var(--ix-border-secondary) !important;\n    padding: 10px !important;\n}\n.ix-row-header {\n    padding: 10px !important;\n    cursor: pointer;\n    font-size: 16px !important;\n}\n.ix-table-row-secondary{\n    background: #f6f8fa;\n}\ntr {\n    border: 1px solid #EAECEF !important;\n    border-bottom: 1px solid #EAECEF!important;\n}\n\n", ""]);

// exports
